import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

export class EventService {
    static async getLastEvents(_deviceId: string | undefined | null = undefined, _take: number | undefined = undefined) {
        try {
            var inputObj = {
                "deviceId": _deviceId,
                "take": _take
            }

            console.log('SERVICE CALL - GetLastEvents', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Event/GetLastEvents', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}